import { useField } from 'react-final-form'
import { validate } from '@captaincause/lib/form/validators'
import { Checkbox } from '.'
import type { CheckboxProps } from '.'
import type { ValidatorsAndCustoms } from '@captaincause/lib/form/validators'
import type { Locales } from '@captaincause/types'
import type { ReactNode } from 'react'

interface CheckboxFieldProps
  extends Omit<CheckboxProps, 'field' | 'required' | 'checked' | 'label'> {
  children: ReactNode
  name: string
  validators?: ValidatorsAndCustoms
  locale: Locales
  onchange?: (event: React.ChangeEvent<HTMLInputElement> | any) => void
}

const emptyObjet = {}
const noop = () => {}
export function CheckboxField({
  children,
  name,
  validators = emptyObjet,
  locale,
  onchange = noop,
  ...props
}: CheckboxFieldProps) {
  const { input, meta } = useField<string, HTMLInputElement>(name, {
    type: 'checkbox',
    parse: v => v,
    validate: validate(validators, locale),
  })

  return (
    <Checkbox
      formMeta={meta}
      required={!!validators.mustBeRequired}
      blur={input.onBlur}
      change={e => {
        onchange(e)
        input.onChange(e)
      }}
      focus={input.onFocus}
      label={children}
      name={name}
      checked={input.checked!}
      {...props}
    />
  )
}
